import {
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import MainCard from "ui-component/cards/MainCard";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import axios from "axios";

const UpdateSelfWorkingDetails = ({ alumniDetails, hasMultipleCurrent, setAlumniDetails, alumniId, setOpenEdit }) => {
    const RequestId = useRequestIdGenerater();
    const Role = localStorage.getItem("role")

    const [industriesList, setIndustriesList] = useState([])
    const [functionAreaList, setFuctionalAreaList] = useState([])

    const { rendomRequestId, generateTimeStamp } = useTimeStamp();
    const getMonth = (dateStr) => {
        if (!dateStr) return "";
        return (new Date(dateStr).getMonth() + 1).toString();
    };

    const getYear = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).getFullYear().toString();
    };

    const parseAlumniDetail = (detail) => ({
        id: detail?.id ?? "",
        present: detail?.present,
        startDate: detail?.startDate ?? "",
        endDate: detail?.endDate ?? "",
        designation: detail?.designation ?? "",
        industries: detail?.industries ?? "",
        functionalArea: detail?.functionalArea ?? "",
        detailRole: detail?.detailRole ?? "",
        otherFunctionalArea: detail?.otherFunctionalArea ?? '',
        otherIndustries: detail?.otherIndustries ?? '',
        startMonth: getMonth(detail?.startMonth),
        startYear: getYear(detail?.startYear),
        endMonth: getMonth(detail?.endMonth),
        endYear: getYear(detail?.endYear),
    });

    const initialValues = {
        selfWorkingDetails: Array.isArray(alumniDetails)
            ? alumniDetails.map(parseAlumniDetail)
            : [parseAlumniDetail(alumniDetails ?? {})]
    };
    const handleSubmit = (values) => {
        const payload = {
            ...values.selfWorkingDetails?.[0] || {},
            otherFunctionalArea: values.selfWorkingDetails?.[0].otherFunctionalArea ? values.selfWorkingDetails?.[0].otherFunctionalArea : "",
            otherIndustries: values.selfWorkingDetails?.[0].otherIndustries ? values.selfWorkingDetails?.[0].otherIndustries : "",
        }
        axios
            .put(`/v1/alumni/update-individual/self-working-details?alumniId=${alumniId}`, payload, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        "serviceToken"
                    )}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        values?.selfWorkingDetails[0].detailRole,
                        values?.selfWorkingDetails[0].designation + rendomRequestId
                    ),
                },
            })
            .then((value) => {
                setAlumniDetails(value?.data?.data)
                generateTimeStamp();
                dispatch(
                    openSnackbar({
                        open: true,
                        message: "Updated Successfully.",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                        close: false,
                    })
                );
                setOpenEdit(false)

            })
            .catch((error) => {
                if (error.response.status === 404) {
                    generateTimeStamp();
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: error.response.data.Msg,
                            variant: "alert",
                            alert: {
                                color: "error",
                            },
                            close: false,
                        })
                    );
                } else {
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: "Something went wrong",
                            variant: "alert",
                            alert: {
                                color: "error",
                            },
                            close: false,
                        })
                    );
                    generateTimeStamp();
                }
            });
    };


    const fetchData = async (endpoint, processResponse) => {
        let url = `/v1/${endpoint}`;
        const instituteId =
            Role === "ROLE_COLLEGE_ADMIN" ? localStorage.getItem("instituteId") : "";
        if (instituteId) {
            url += `?instituteId=${instituteId}`;
        }

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        "serviceToken"
                    )}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
                    ),
                },
            });

            processResponse(response);
        } catch (err) {
            console.log(err);
        }
    };

    const getIndustriesList = () => {
        fetchData("master/industries", (response) => {
            setIndustriesList(response?.data?.data);
        });
    };
    const getFunctionalArea = () => {
        fetchData("master/functional-area", (response) => {
            setFuctionalAreaList(response?.data?.data);
        });
    };

    useEffect(() => {
        getIndustriesList();
        getFunctionalArea();
        generateTimeStamp();
    }, []);

    console.log(hasMultipleCurrent, 'hasMultipleCurrent')

    return (
        <MainCard>
            {/* {hasMultipleCurrent && (
                <Typography color="error" sx={{ fontSize: "0.9rem", mb: 2 }}>
                    Please provide the end date for this position. You have already marked another experience as your current position.
                </Typography>
            )} */}

            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ values, handleChange, touched, errors, setFieldValue }) => (
                    <Form>
                        <FieldArray
                            name="selfWorkingDetails"
                            render={(arrayHelpers) => (
                                <>
                                    {values.selfWorkingDetails && values.selfWorkingDetails.length > 0
                                        ? values.selfWorkingDetails.map((items, i) => {
                                            return (
                                                <React.Fragment key={i}>
                                                    <Grid container spacing={1}>

                                                        <Grid item xs={12} md={4}>
                                                            <TextField
                                                                fullWidth
                                                                type="text"
                                                                id={`selfWorkingDetails.${i}.designation`}
                                                                name={`selfWorkingDetails.${i}.designation`}
                                                                label="Designation"
                                                                value={items.designation}
                                                                onChange={handleChange}
                                                                error={
                                                                    touched.selfWorkingDetails?.[i]?.designation &&
                                                                    Boolean(errors.selfWorkingDetails?.[i]?.designation)
                                                                }
                                                                helperText={
                                                                    touched.selfWorkingDetails?.[i]?.designation &&
                                                                    errors.selfWorkingDetails?.[i]?.designation
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <FormControl fullWidth error={touched.industries && Boolean(errors.industries)}>
                                                                <InputLabel id="Industry-select">Industry</InputLabel>
                                                                <Select
                                                                    labelId="Industry-select"
                                                                    id={`selfWorkingDetails.${i}.industries`}
                                                                    name={`selfWorkingDetails.${i}.industries`}
                                                                    onChange={(e) => {
                                                                        const selectedValue = e.target.value;
                                                                        handleChange(e);

                                                                        // If "Other" is selected, set otherIndustries as an empty string for manual input
                                                                        setFieldValue(`selfWorkingDetails.${i}.otherIndustries`, selectedValue === "Other" ? "" : null);
                                                                    }}
                                                                    value={items?.industries || ""}
                                                                    label="Industry"
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>None</em>
                                                                    </MenuItem>
                                                                    {industriesList?.map((data) => (
                                                                        <MenuItem key={data?.name} value={data?.name}>
                                                                            {data?.name}
                                                                        </MenuItem>
                                                                    ))}
                                                                    <MenuItem value="Other">Other</MenuItem>
                                                                </Select>
                                                            </FormControl>

                                                            {items?.industries === "Other" && (
                                                                <TextField
                                                                    fullWidth
                                                                    label="Enter Industry"
                                                                    value={items.otherIndustries}
                                                                    onChange={(e) => setFieldValue(`selfWorkingDetails.${i}.otherIndustries`, e.target.value)}
                                                                    margin="dense"
                                                                />
                                                            )}
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <FormControl fullWidth error={touched.functionalArea && Boolean(errors.functionalArea)}>
                                                                <InputLabel id="functionalArea-select">Functional Area</InputLabel>
                                                                <Select
                                                                    labelId="functionalArea-select"
                                                                    id={`selfWorkingDetails.${i}.functionalArea`}
                                                                    name={`selfWorkingDetails.${i}.functionalArea`}
                                                                    onChange={(e) => {
                                                                        const selectedValue = e.target.value;
                                                                        handleChange(e);

                                                                        // If "Other" is selected, set otherFunctionalArea as an empty string for manual input
                                                                        setFieldValue(`selfWorkingDetails.${i}.otherFunctionalArea`, selectedValue === "Other" ? "" : null);
                                                                    }}
                                                                    value={items?.functionalArea || ""}
                                                                    label="Functional Area"
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>None</em>
                                                                    </MenuItem>
                                                                    {functionAreaList?.map((data) => (
                                                                        <MenuItem key={data?.name} value={data?.name}>
                                                                            {data?.name}
                                                                        </MenuItem>
                                                                    ))}
                                                                    <MenuItem value="Other">Other</MenuItem>
                                                                </Select>
                                                            </FormControl>

                                                            {items?.functionalArea === "Other" && (
                                                                <TextField
                                                                    fullWidth
                                                                    label="Enter Functional Area"
                                                                    value={items.otherFunctionalArea}
                                                                    onChange={(e) => setFieldValue(`selfWorkingDetails.${i}.otherFunctionalArea`, e.target.value)}
                                                                    margin="dense"
                                                                />
                                                            )}
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            <TextField
                                                                multiline
                                                                rows={2}
                                                                fullWidth
                                                                id={`selfWorkingDetails.${i}.detailRole`}
                                                                name={`selfWorkingDetails.${i}.detailRole`}
                                                                label="Employment Details"
                                                                value={items.detailRole}
                                                                onChange={handleChange}
                                                                error={
                                                                    touched.selfWorkingDetails?.[i]?.detailRole &&
                                                                    Boolean(errors.selfWorkingDetails?.[i]?.detailRole)
                                                                }
                                                                helperText={
                                                                    touched.selfWorkingDetails?.[i]?.detailRole &&
                                                                    errors.selfWorkingDetails?.[i]?.detailRole
                                                                }
                                                            />
                                                        </Grid>


                                                        <Grid item xs={12}>
                                                            <Typography sx={{ p: 1 }}>Start Date</Typography>
                                                            <Grid container spacing={1}>
                                                                <Grid item xs={12} md={6}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        error={
                                                                            touched.selfWorkingDetails?.[i]?.startMonth &&
                                                                            Boolean(errors.selfWorkingDetails?.[i]?.startMonth)
                                                                        }
                                                                    >
                                                                        <InputLabel>Month</InputLabel>
                                                                        <Select
                                                                            name={`selfWorkingDetails.${i}.startMonth`}
                                                                            value={items.startMonth || ""}
                                                                            onChange={handleChange}
                                                                            label="Month"
                                                                        >
                                                                            {[
                                                                                "January",
                                                                                "February",
                                                                                "March",
                                                                                "April",
                                                                                "May",
                                                                                "June",
                                                                                "July",
                                                                                "August",
                                                                                "September",
                                                                                "October",
                                                                                "November",
                                                                                "December",
                                                                            ].map((month, index) => (
                                                                                <MenuItem key={index} value={index + 1}>
                                                                                    {month}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                        <FormHelperText>
                                                                            {touched.selfWorkingDetails?.[i]?.startMonth &&
                                                                                errors.selfWorkingDetails?.[i]?.startMonth}
                                                                        </FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        error={
                                                                            touched.selfWorkingDetails?.[i]?.startYear &&
                                                                            Boolean(errors.selfWorkingDetails?.[i]?.startYear)
                                                                        }
                                                                    >
                                                                        <InputLabel>Year</InputLabel>
                                                                        <Select
                                                                            name={`selfWorkingDetails.${i}.startYear`}
                                                                            value={items.startYear || ""}
                                                                            onChange={handleChange}
                                                                            label="Year"
                                                                            MenuProps={{
                                                                                PaperProps: {
                                                                                    style: {
                                                                                        maxHeight: 200,
                                                                                    },
                                                                                },
                                                                            }}
                                                                        >
                                                                            {Array.from({ length: 30 }, (_, idx) => {
                                                                                const year = new Date().getFullYear() - idx;
                                                                                return (
                                                                                    <MenuItem key={year} value={year}>
                                                                                        {year}
                                                                                    </MenuItem>
                                                                                );
                                                                            })}
                                                                        </Select>
                                                                        <FormHelperText>
                                                                            {touched.selfWorkingDetails?.[i]?.startYear &&
                                                                                errors.selfWorkingDetails?.[i]?.startYear}
                                                                        </FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        {/* Present Checkbox */}
                                                        <Grid item xs={12} md={4} sx={{ p: 0 }}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        name={`selfWorkingDetails.${i}.present`}
                                                                        checked={items.present}
                                                                        onChange={handleChange}
                                                                    />
                                                                }
                                                                label="Present"
                                                            />
                                                        </Grid>

                                                        {/* End Date */}
                                                        {(!items.present) && (
                                                            <Grid item xs={12}>
                                                                <Typography sx={{ p: 1 }}>End Date</Typography>
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={6} md={6}>
                                                                        <FormControl
                                                                            fullWidth
                                                                            error={
                                                                                touched.selfWorkingDetails?.[i]?.endMonth &&
                                                                                Boolean(errors.selfWorkingDetails?.[i]?.endMonth)
                                                                            }
                                                                        >
                                                                            <InputLabel>Month</InputLabel>
                                                                            <Select
                                                                                name={`selfWorkingDetails.${i}.endMonth`}
                                                                                value={items.endMonth || ""}
                                                                                onChange={handleChange}
                                                                                label="Month"
                                                                            >
                                                                                {[
                                                                                    "January",
                                                                                    "February",
                                                                                    "March",
                                                                                    "April",
                                                                                    "May",
                                                                                    "June",
                                                                                    "July",
                                                                                    "August",
                                                                                    "September",
                                                                                    "October",
                                                                                    "November",
                                                                                    "December",
                                                                                ].map((month, index) => (
                                                                                    <MenuItem key={index} value={index + 1}>
                                                                                        {month}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                            <FormHelperText>
                                                                                {touched.selfWorkingDetails?.[i]?.endMonth &&
                                                                                    errors.selfWorkingDetails?.[i]?.endMonth}
                                                                            </FormHelperText>
                                                                        </FormControl>
                                                                    </Grid>

                                                                    <Grid item xs={6} md={6}>
                                                                        <FormControl
                                                                            fullWidth
                                                                            error={
                                                                                touched.selfWorkingDetails?.[i]?.endYear &&
                                                                                Boolean(errors.selfWorkingDetails?.[i]?.endYear)
                                                                            }
                                                                        >
                                                                            <InputLabel>Year</InputLabel>
                                                                            <Select
                                                                                name={`selfWorkingDetails.${i}.endYear`}
                                                                                value={items.endYear || ""}
                                                                                onChange={handleChange}
                                                                                label="Year"
                                                                                MenuProps={{
                                                                                    PaperProps: {
                                                                                        style: {
                                                                                            maxHeight: 200,
                                                                                        },
                                                                                    },
                                                                                }}
                                                                            >
                                                                                {Array.from({ length: 30 }, (_, idx) => {
                                                                                    const year = new Date().getFullYear() - idx;
                                                                                    return (
                                                                                        <MenuItem key={year} value={year}>
                                                                                            {year}
                                                                                        </MenuItem>
                                                                                    );
                                                                                })}
                                                                            </Select>
                                                                            <FormHelperText>
                                                                                {touched.selfWorkingDetails?.[i]?.endYear &&
                                                                                    errors.selfWorkingDetails?.[i]?.endYear}
                                                                            </FormHelperText>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </React.Fragment>
                                            );
                                        })
                                        : null}
                                </>
                            )}
                        />
                        <Grid
                            item
                            md={12}
                            xs={12}
                            sx={{
                                mt: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button variant="contained" color="secondary" type="button" onClick={() => setOpenEdit(false)}>Close</Button>
                            <Button variant="contained" color="primary" type="submit" sx={{ ml: 2 }}>
                                Update
                            </Button>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </MainCard>
    );
};

export default UpdateSelfWorkingDetails;
